import { getStoreDefinition } from '@/composables/StoreDefinition'
import { EndPoint } from '@/enums/EndPoint'
import { SqlComparison } from '@/enums/SqlComparison'
import { TableStoreOptions } from '@/enums/TableStoreOptions'
import type { IEmailTemplatesStore } from '@/interfaces/api/IEmailTemplatesStore'
import type { IPaginatedResults } from '@/interfaces/api/IPaginatedResults'
import type { IQueryOptions } from '@/interfaces/api/IQueryOptions'
import type { ITableStore } from '@/interfaces/api/ITableStore'
import { defineStore } from 'pinia'
import { useSettingsStore } from '../ui/SettingsStore'
import { useAPIStore } from './ApiStore'

let _store: IEmailTemplatesStore

const mergeDefaultsWithCustom = async (
  itemQuery: IQueryOptions,
  results: IPaginatedResults
): Promise<IPaginatedResults> => {
  const filteredItems: IPaginatedResults = {
    results: [],
    count: 0
  }

  const apiStore = useAPIStore()

  const options = { ...itemQuery }
  delete options.returnDefaults
  delete options.limit
  delete options.offset

  const response = await apiStore.getMany(EndPoint.EmailTemplates, options)
  if (!response.error) {
    filteredItems.count = results.count
    const defaultItems = results.results
    const customItems = response.data.results
    defaultItems.forEach((defaultItem) => {
      const customItem = customItems.find((customItem) => {
        return customItem.type === defaultItem.type
      })
      if (customItem) {
        filteredItems.results.push(customItem)
      } else {
        filteredItems.results.push(defaultItem)
      }
    })
  }

  return filteredItems
}

export const useEmailTemplatesStore = (): ITableStore => {
  if (_store) {
    return _store
  }
  const option = TableStoreOptions.EmailTemplates
  const useStore = defineStore(option.id, getStoreDefinition(option), {
    persist: {
      storage: localStorage,
      pick: ['itemsPerPage']
    }
  })
  _store = useStore() as unknown as IEmailTemplatesStore
  _extend(_store)
  return _store
}
const _extend = (store: IEmailTemplatesStore) => {
  const settingsStore = useSettingsStore()

  store.itemsTransform = mergeDefaultsWithCustom
  store.localeCode = settingsStore.globals.defaultLocaleCode
  store.itemQuery = {
    returnDefaults: true,
    where: [
      {
        field: 'locale',
        comparison: SqlComparison.Equal,
        value1: store.localeCode
      }
    ]
  }
}
